<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M190 218 327.7 80.3c7-7.2 17.3-10.1 27.1-7.6 9.7 2.5 17.3 10.1 19.9 19.9 2.5 9.7-.4 20.1-7.6 27.1L209.7 277c-5.2 5.2-12.3 8.2-19.7 8.2-7.4 0-14.5-3-19.7-8.2l-78.7-78.6c-10.5-10.9-10.4-28.3.3-39 10.7-10.7 28.1-10.9 39-.3L190 218zm0 333.8 137.7-137.7c7-7.2 17.3-10.1 27.1-7.6 9.7 2.5 17.3 10.1 19.9 19.9 2.5 9.7-.4 20.1-7.6 27.1L209.7 610.8c-5.2 5.2-12.3 8.2-19.7 8.2-7.4 0-14.5-3-19.7-8.2l-78.7-78.6c-10.5-10.9-10.4-28.3.3-39 10.7-10.7 28.1-10.9 39-.3l59.1 58.9zm721.8-317.7H461.6c-16 0-29-13-29-29s13-29 29-29h450.2c16 0 29 13 29 29s-12.9 29-29 29zm0 317.8H461.6c-16 0-29-13-29-29s13-29 29-29h450.2c16 0 29 13 29 29s-12.9 29-29 29zm0 315.9H461.6c-16 0-29-13-29-29s13-29 29-29h450.2c16 0 29 13 29 29s-12.9 29-29 29zm-689 84c-62.3 0-113-50.7-113-113s50.7-113 113-113 113 50.7 113 113-50.7 113-113 113zm0-168.1c-30.3 0-55 24.7-55 55s24.7 55 55 55 55-24.7 55-55-24.7-55-55-55z"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
